import * as React from 'react';
import { CheckBox } from '@gandi/ui';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
function CheckBoxCompat(_props) {
  const {
    isField,
    value,
    ...props
  } = _props;
  const compatProps = {};
  if (typeof value === 'boolean' && !('checked' in props)) {
    compatProps.checked = value;
  }
  return /*#__PURE__*/_jsx(CheckBox, {
    ...props,
    ...compatProps
  });
}
const component = decorateControl(CheckBoxCompat, FormGroup);
const CheckboxField = props => /*#__PURE__*/_jsx(FormField, {
  ...props,
  component: component
});
export default CheckboxField;